import React from 'react';
import { Box } from '@mui/material';
import { Projects } from '../projects';

/**
 * Management mode: Projects grid (hierarchical view).
 * Rendered from ProjectsPage when no search query (?q=) is present.
 */
const ProjectHierarchyView = () => (
  <Box sx={{ width: '100%' }}>
    <Projects />
  </Box>
);

export default ProjectHierarchyView;
